import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setCurrentUser } from "../reducers/authSlice";
import Services from "../services/services";
import { RoutePages } from "../ultils";

const AuthenticationForm = () => {
    const [isSignup, setIsSignup] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [email, setEmail] = useState(null);
    const [passwordConfirm, setPasswordConfirm] = useState(null);
    const [displayName, setDisplayName] = useState(null);
    const [refId, setRefId] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleLogin = async () => {
        const result = await Services.UserPublic.login(username, password);
        const data = await result.json();
        if (result.ok) {
            if (data.success === true) {
                dispatch(setCurrentUser(data.data))
                navigate(RoutePages.API_STATUS.path);
                toast.success("Logged in!");
            }
            else {
                toast.error(data.error);
            }
        }
        else if (result.status === 401) {
            toast.error("Login information is wrong or not existed!");
        }
        else {
            toast.error("Connection error!");
        }
    }

    const handleRegister = async () => {
        if (password !== passwordConfirm) {
            toast.error("Confirm password is not matched!");
            return;
        }
        if (!password || !username || !email || !displayName) {
            toast.error("Please fill fully your informations!");
            return;
        }

        const result = await Services.UserPublic.register(username, password, passwordConfirm, displayName, email, refId);
        const json = await result.json();
        if (result.status === 200 && json.success === true) {
            toast.success("Welcome to AK-API! Please login!");
            setIsSignup(false);
        }
        else {
            toast.error(`${result.status}: ${json.error ?? ""}`);
        }
    }

    return (
        <div className="flex flex-col items-center justify-center w-fit">
            <h2 className="text-3xl font-bold text-center mb-12 text-blue-900 tracking-tight">
                Sign Up Now – Free Forever
            </h2>
            <div className="w-full max-w-md bg-white rounded-lg shadow p-6 flex flex-col gap-4">
                <div className="flex justify-center mb-2">
                    <button
                        className={`px-4 py-2 rounded-l ${!isSignup ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}`}
                        onClick={() => setIsSignup(false)}
                    >
                        Login
                    </button>
                    <button
                        className={`px-4 py-2 rounded-r ${isSignup ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}`}
                        onClick={() => setIsSignup(true)}
                    >
                        Register
                    </button>
                </div>
                <form
                    className="flex flex-col gap-4"
                    onSubmit={e => {
                        e.preventDefault();
                        isSignup ? handleRegister() : handleLogin();
                    }}
                >
                    <input
                        type="text"
                        required
                        placeholder="Username (required)"
                        className="border p-3 rounded"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />
                    <input
                        type="password"
                        required
                        placeholder="Password (required)"
                        className="border p-3 rounded"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        onKeyDown={e => !isSignup && e.key === "Enter" && handleLogin()}
                    />
                    {isSignup && (
                        <>
                            <input
                                type="password"
                                required
                                placeholder="Confirm password (required)"
                                className="border p-3 rounded"
                                value={passwordConfirm}
                                onChange={e => setPasswordConfirm(e.target.value)}
                            />
                            <input
                                type="email"
                                required
                                placeholder="Email (required, will be verified)"
                                className="border p-3 rounded"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                            <input
                                type="text"
                                required
                                placeholder="Your name (required)"
                                className="border p-3 rounded"
                                value={displayName}
                                onChange={e => setDisplayName(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Referrer ID (optional)"
                                className="border p-3 rounded"
                                value={refId}
                                onChange={e => setRefId(e.target.value)}
                            />
                        </>
                    )}
                    <button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded transition"
                    >
                        {isSignup ? "Register" : "Login"}
                    </button>
                </form>
                {isSignup === false && <button
                    className="text-blue-500 text-sm underline"
                    onClick={() => navigate(RoutePages.FORGOTTEN_PASSWORD.path)}
                >
                    Forgotten password?
                </button>}
                <p className="text-center text-sm">
                    {isSignup ? "Already have an account?" : "Have no account?"}{" "}
                    <button
                        className="text-blue-500 underline"
                        onClick={() => setIsSignup(!isSignup)}
                    >
                        {isSignup ? "Login now" : "Register now"}
                    </button>
                </p>
                <p className="text-xs text-gray-500 text-center">No credit card required. Free forever.</p>
            </div>
        </div>
    );
};

export default AuthenticationForm;
